import { AlignmentType, Document, Header as DocXHeader } from "docx";
import { Body, breakLine, C, Header, line, text } from "./common";
import { get, uniq } from "lodash";

const getHotelCardForm = (item: any, isViags: boolean = true) => {
  const jsonString = item.eContent;
  const dataArray = JSON.parse(jsonString);
  const length = dataArray?.length ?? 0;
  const isLongTerm = item.eStage === "longTerm";
  const stage = isLongTerm ? "dài hạn" : "ngắn hạn";
  const suggestion = !isLongTerm
    ? item.eSuggestion === "provide"
      ? "cấp"
      : "cấp lại"
    : item.eSuggestion === "provide"
    ? "cấp mới"
    : item.eSuggestion === "evict"
    ? "gia hạn"
    : "cấp lại";

  const join = (name: string, joinString: string = ", ") => {
    try {
      return uniq(dataArray.map((item: any) => get(item, name))).join(joinString);
    } catch (error) {
      return "";
    }
  };

  const getDepartment = () => {
    const eDepartment = get(item, "eDepartment") as string;

    const department = ["Tân Sơn Nhất", "Nội Bài", "Đà Nẵng"].find((d) => eDepartment.includes(d));

    return department ? ` – VIAGS ${department}` : "";
  };

  // Create the document
  return new Document({
    sections: [
      {
        headers: {
          default: new DocXHeader({
            children: [
              C.row(
                C.col(undefined, [
                  text({ text: "TCT HÀNG KHÔNG VIỆT NAM", size: 22 }, { alignment: AlignmentType.CENTER }),
                  text(
                    { text: "CÔNG TY DVMĐ SÂN BAY VIỆT NAM", size: 24, bold: true },
                    { alignment: AlignmentType.CENTER },
                  ),
                  line(900),
                ]),
                C.col(undefined, Header.rightParagraph),
              ),
            ],
          }),
        },
        children: isLongTerm
          ? /** Long term */ [
              C.row(
                C.col(undefined, [
                  text("Số:\t\t/VIAGS-VPCT", { alignment: AlignmentType.CENTER }),
                  text(
                    { text: `V/v cấp thẻ KSAN ${stage} năm 2025-2026`, size: 24 },
                    { alignment: AlignmentType.CENTER },
                  ),
                  text(isViags ? "Cán bộ, Nhân viên VIAGS TSN" : "Nhân viên Công ty đối tác VIAGS", {
                    alignment: AlignmentType.CENTER,
                  }),
                ]),
                C.col(undefined, [Body.Date]),
              ),

              breakLine(1),

              text("Kính gửi: Công an cửa khẩu Cảng hàng không quốc tế Tân Sơn Nhất", {
                alignment: AlignmentType.CENTER,
              }),

              breakLine(1),

              text([
                {
                  text: `\tCăn cứ các quy định của pháp luật liên quan đến việc cấp, đổi thẻ kiểm soát an ninh hàng không (thẻ KSAN);`,
                  italics: true,
                },
              ]),

              breakLine(1),

              text([
                {
                  text: `\tCăn cứ các Quyết định bổ nhiệm Cán bộ của Trung tâm Phục vụ hành khách – VIAGS Tân Sơn Nhất.`,
                  italics: true,
                },
              ]),

              breakLine(1),

              text(
                `\tVIAGS kính đề nghị Công an cửa khẩu Cảng hàng không quốc tế Tân Sơn Nhất xem xét và phê duyệt cấp ${suggestion} thẻ KSAN ${stage} năm 2025-2026 cho ${length} nhân viên ${
                  isViags ? "" : `các công ty đối tác của VIAGS là ${join("unit")}`
                } thuộc ${get(item, "eUnit")} để nhân viên được phép ra/vào khu vực hạn chế làm việc theo quy định.`,
              ),

              breakLine(1),

              text(
                "\tĐối với trường hợp kiểm tra án tích của các Cán bộ, nhân viên, VIAGS cam kết và xác nhận các trường hợp đề nghị cấp thẻ kiểm soát an ninh đã được kiểm tra và không có án tích.",
              ),

              breakLine(1),

              text(`\tMọi thông tin chi tiết, xin liên hệ: Bùi Thị Sương.`),

              breakLine(1),

              text(`\tTel: (028) 35472288, Fax: (028) 35471188, Ext 6340, Mobile: 035.847.2555.`),

              breakLine(1),

              text(`\tEmail: suongbt@viags.vn.  `),

              breakLine(1),

              text("\tTrân trọng cảm ơn./."),

              breakLine(1),

              C.row(C.col(50, [Body.save("Như trên;", "Lưu: VT")]), C.col(50, [Body.sign3])),
            ]
          : /** Short term */ [
              C.row(
                C.col(undefined, [
                  text("Số:\t\t/VIAGS-VP", { alignment: AlignmentType.CENTER }),
                  text(`V/v cấp thẻ KSAN ${stage}`, { alignment: AlignmentType.CENTER }),
                  text(" CBNV VIAGS", { alignment: AlignmentType.CENTER }),
                ]),
                C.col(undefined, [Body.Date]),
              ),

              breakLine(1),

              text("Kính gửi: Công an cửa khẩu Cảng hàng không quốc tế Tân Sơn Nhất", {
                alignment: AlignmentType.CENTER,
              }),

              breakLine(1),

              text([
                {
                  text: `\tCăn cứ các quy định pháp luật liên quan đến việc cấp, đổi thẻ kiểm soát an ninh hàng không (thẻ KSAN).`,
                  italics: true,
                },
              ]),

              breakLine(1),

              text(
                `\tVIAGS kính đề nghị Công an cửa khẩu Cảng hàng không quốc tế Tân Sơn Nhất xem xét và phê duyệt ${suggestion} thẻ KSAN ${stage} cho ${length} nhân viên hiện đang làm việc tại đơn vị ${join(
                  "unit",
                )} thuộc ${get(
                  item,
                  "eUnit",
                )}${getDepartment()} để nhân viên được phép ra/vào khu vực hạn chế làm việc theo quy định.`,
              ),

              breakLine(1),

              text(
                `\tĐối với trường hợp kiểm tra án tích của các Cán bộ, nhân viên, VIAGS cam kết và xác nhận các trường hợp đề nghị cấp thẻ kiểm soát an ninh đã được kiểm tra và không có án tích.`,
              ),

              breakLine(1),

              text(`\tMọi thông tin chi tiết, xin liên hệ: Bà Bùi Thị Sương.`),

              breakLine(1),

              text(`\tTel: (028) 35472288, Fax: (028) 35471188, Ext 6340.`),
              text(`\tMobile: 035.847.2555.`),
              text(`\tEmail: suongbt@viags.vn.`),
              text(`\tTrân trọng cảm ơn./.`),

              breakLine(1),

              C.row(C.col(50, [Body.save("Như trên;", "Lưu: VT")]), C.col(50, [Body.sign3])),
            ],
      },
      /** New Page */
      // {
      //   headers: {
      //     default: new DocXHeader({
      //       children: [
      //         C.row(
      //           C.col(undefined, [
      //             text(
      //               { text: "TCT HÀNG KHÔNG VIỆT NAM", size: 24, bold: true },
      //               { alignment: AlignmentType.CENTER }
      //             ),
      //             text(
      //               { text: "CÔNG TY DVMĐ SÂN BAY VIỆT NAM", size: 24, bold: true },
      //               { alignment: AlignmentType.CENTER }
      //             ),
      //           ]),
      //           C.col(undefined, Header.rightParagraph)
      //         ),
      //       ],
      //     }),
      //   },
      //   properties: {
      //     page: {
      //       size: {
      //         orientation: PageOrientation.LANDSCAPE,
      //       },
      //       margin: {
      //         top: 1800,
      //         bottom: 1800,
      //         left: 2160,
      //         right: 1440
      //       }
      //     },
      //   },
      //   children: [
      //     breakLine(1),

      //     ...(isLongTerm
      //       ? /** Dài hạn */
      //         [
      //           text(
      //             [
      //               {
      //                 text: "DANH SÁCH TRÍCH NGANG CÁN BỘ NHÂN VIÊN ĐỀ NGHỊ CẤP",
      //                 bold: true,
      //               },
      //               {
      //                 text: "THẺ KIỂM SOÁT AN NINH CÓ GIÁ TRỊ SỬ DỤNG DÀI HẠN",
      //                 bold: true,
      //                 break: 1,
      //               },
      //             ],
      //             {
      //               alignment: AlignmentType.CENTER,
      //             }
      //           ),

      //           text(
      //             [
      //               {
      //                 text: "(Kèm theo công văn số        /VIAGS-VP ngày     tháng     năm        )",
      //                 italics: true,
      //               },
      //             ],
      //             {
      //               alignment: AlignmentType.CENTER,
      //             }
      //           ),

      //           breakLine(1),

      //           text("Kính gửi: CẢNG VỤ HÀNG KHÔNG MIỀN NAM", { alignment: AlignmentType.CENTER }),

      //           breakLine(2),

      //           table<{
      //             name: string;
      //             sex: string;
      //             personalId: number;
      //             unit: string;
      //             regency: string;
      //             KSANCardNumberIssued: string;
      //             grantTerm: string;
      //             note: string;
      //             grantedArea: { value: string }[];
      //           }>({
      //             columns: [
      //               {
      //                 label: "TT",
      //                 renderText: (item, index) => text((index + 1).toString()),
      //               },
      //               {
      //                 label: "Họ và tên",
      //                 renderText: (item) => text(item.name),
      //               },
      //               {
      //                 label: "Chức danh",
      //                 renderText: (item) => text(item.regency),
      //               },
      //               {
      //                 label: "Đơn vị",
      //                 renderText: (item) => text(isViags ? "VIAGS" : ""),
      //               },
      //               {
      //                 label: "Số CMND/Hộ chiếu",
      //                 renderText: (item) => text(item.personalId.toString()),
      //               },
      //               {
      //                 label: "Số thẻ đã cấp",
      //                 renderText: (info) => text(item.eSuggestion === "provide" ? suggestion : info.KSANCardNumberIssued),
      //               },
      //               {
      //                 label: "Thời hạn cấp",
      //                 renderText: (item) => text(item.grantTerm),
      //               },
      //               {
      //                 label: "Khu vực đề nghị",
      //                 renderText: (item) => text(grantedAreaGenerate(item.grantedArea)),
      //               },
      //               {
      //                 label: "Mục đích",
      //                 renderText: (item) => text(item.note),
      //               },
      //             ],
      //             data: dataArray,
      //           }),
      //         ]
      //       : /** Ngắn hạn */
      //         [
      //           text(
      //             [
      //               {
      //                 text: "DANH SÁCH ĐỀ NGHỊ CẤP THẺ KIỂM SOÁT AN NINH CẢNG HÀNG KHÔNG,",
      //                 bold: true,
      //               },
      //               {
      //                 text: "SÂN BAY CÓ GIÁ TRỊ SỬ DỤNG NGẮN HẠN",
      //                 bold: true,
      //                 break: 1,
      //               },
      //             ],
      //             {
      //               alignment: AlignmentType.CENTER,
      //             }
      //           ),

      //           text(
      //             [
      //               {
      //                 text: `(Kèm theo công văn số        /VIAGS-VP ngày     tháng     năm        của VIAGS)`,
      //                 italics: true,

      //               },
      //             ],
      //             {
      //               alignment: AlignmentType.CENTER,
      //             }
      //           ),

      //           breakLine(2),

      //           table<{
      //             name: string;
      //             sex: string;
      //             personalId: number;
      //             unit: string;
      //             note: string;
      //             regency: string;
      //             grantTerm: string;
      //             grantedArea: any[];
      //           }>({
      //             columns: [
      //               {
      //                 label: "STT",
      //                 renderText: (item, index) => text((index + 1).toString()),
      //               },
      //               {
      //                 label: "Họ và tên",
      //                 renderText: (item) => text(item.name),
      //               },
      //               {
      //                 label: "Nam/Nữ",
      //                 renderText: (item) => text(item.sex),
      //               },
      //               {
      //                 label: "Số CMND/Hộ chiếu",
      //                 renderText: (item) => text(item.personalId.toString()),
      //               },
      //               {
      //                 label: "Chức vụ",
      //                 renderText: (item) => text(item.regency),
      //               },
      //               {
      //                 label: "Đơn vị",
      //                 renderText: (item) => text(isViags ? "VIAGS" : ""),
      //               },
      //               {
      //                 label: "Khu vực hạn chế hoạt động",
      //                 renderText: (item) => text(grantedAreaGenerate(item.grantedArea)),
      //               },
      //               {
      //                 label: "Hạn sử dụng của thẻ kiếm soát an ninh",
      //                 renderText: (item) => text(item.grantTerm),
      //               },
      //               {
      //                 label: "Mục đích",
      //                 renderText: (item) => text(item.note),
      //               },
      //             ],
      //             data: dataArray,
      //           }),
      //         ]),

      //     breakLine(2),

      //     C.row(C.col(50), C.col(50, [!isViags && isLongTerm ? Body.sign : Body.sign2])),
      //   ],
      // },
    ],
  });
};

export default getHotelCardForm;
